import '../scss/accessible-docs-popup.scss';
import Popup from './parts/popup-window';
import { setLinkHref } from './parts/helpers';
import handleSubmitAccessibleDocs from './parts/accessible-docs-handler';
const initAccessibleDocsPopupLogic = () => {
    if (accessible_docs_object.is_popup_enabled !== '1') {
        return;
    }
    const popupInstance = new Popup();
    popupInstance.init();
    document.body.addEventListener('click', (event) => {
        const target = event.target;
        const link = target.closest('a:not(.js-accessible-docs-link)');
        if (link && link.href.includes('.pdf')) {
            event.preventDefault();
            setLinkHref(link.href);
            popupInstance.openOnePopup('.accessible-docs-popup', 50);
        }
        const button = target.closest('.js-accessible-docs-submit');
        if (button) {
            event.preventDefault();
            handleSubmitAccessibleDocs();
        }
    });
};
document.addEventListener('DOMContentLoaded', initAccessibleDocsPopupLogic, false);
